/**
 * n8n and other webhooks do not always return the canonical `ChatResponse` shape
 * (`{ content: { body, format } }`). This normalizes common variants so the UI
 * does not fall through to "incompatible response format" when the model
 * output is present under a different key.
 */
export function extractAssistantMessageText(data: unknown): string | null {
  if (data == null) return null;
  if (typeof data === "string" && data.trim()) return data.trim();

  if (typeof data !== "object") return null;
  const o = data as Record<string, unknown>;

  const content = o.content;
  if (content && typeof content === "object") {
    const c = content as Record<string, unknown>;
    if (typeof c.body === "string" && c.body.trim()) return c.body.trim();
  }

  if (typeof o.agent_response === "string" && o.agent_response.trim()) {
    return o.agent_response.trim();
  }

  for (const key of ["output", "message", "text", "reply", "answer", "response"]) {
    const v = o[key];
    if (typeof v === "string" && v.trim()) return v.trim();
  }

  const choices = o.choices;
  if (Array.isArray(choices) && choices[0] && typeof choices[0] === "object") {
    const c0 = choices[0] as Record<string, unknown>;
    const msg = c0.message;
    if (msg && typeof msg === "object") {
      const m = msg as Record<string, unknown>;
      if (typeof m.content === "string" && m.content.trim()) return m.content.trim();
    }
  }

  const nested = o.data;
  if (nested && typeof nested === "object") {
    const inner = extractAssistantMessageText(nested);
    if (inner) return inner;
  }

  if (import.meta.env.DEV) {
    console.warn("[chat] Unrecognized webhook JSON shape. Top-level keys:", Object.keys(o));
  }

  return null;
}
